module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Referrers":"Referrer","No referrer data available for this period":"Keine Referrer-Daten für diesen Zeitraum verfügbar","Missing Data":"Es fehlen Daten","visitors":"Besucher","Others":"Sonstige"}}')
  delete Component.options._Ctor
}
